module.exports = __webpack_public_path__ + "img/house-laptop.bbdef7bf.svg";